export type Language = {
  code: string;
  name: string;
  english: string;
  flag?: string;
};

export const SUPPORTED_LANGUAGES: Language[] = [
  // Most widely used languages
  { code: "en-gb", name: "English (UK)", english: "English (UK)", flag: "🇬🇧" },
  { code: "en-us", name: "English (US)", english: "English (US)", flag: "🇺🇸" },
  { code: "zh", name: "中文", english: "Chinese (Mandarin)", flag: "🇨🇳" },
  { code: "hi", name: "हिन्दी", english: "Hindi", flag: "🇮🇳" },
  { code: "es", name: "Español", english: "Spanish", flag: "🇪🇸" },
  { code: "ar", name: "العربية", english: "Arabic", flag: "🇸🇦" },
  { code: "bn", name: "বাংলা", english: "Bengali", flag: "🇧🇩" },
  { code: "pt", name: "Português", english: "Portuguese", flag: "🇵🇹" },
  { code: "ru", name: "Русский", english: "Russian", flag: "🇷🇺" },
  { code: "ja", name: "日本語", english: "Japanese", flag: "🇯🇵" },
  { code: "pa", name: "ਪੰਜਾਬੀ", english: "Punjabi", flag: "🇮🇳" },

  // Asian Languages
  { code: "ko", name: "한국어", english: "Korean", flag: "🇰🇷" },
  { code: "yue", name: "粵語", english: "Chinese (Cantonese)", flag: "🇭🇰" },
  { code: "vi", name: "Tiếng Việt", english: "Vietnamese", flag: "🇻🇳" },
  { code: "th", name: "ไทย", english: "Thai", flag: "🇹🇭" },
  { code: "my", name: "မြန်မာစာ", english: "Burmese", flag: "🇲🇲" },
  { code: "km", name: "ភាសាខ្មែរ", english: "Khmer", flag: "🇰🇭" },
  { code: "ms", name: "Bahasa Melayu", english: "Malay", flag: "🇲🇾" },
  { code: "id", name: "Bahasa Indonesia", english: "Indonesian", flag: "🇮🇩" },
  { code: "tl", name: "Tagalog", english: "Tagalog", flag: "🇵🇭" },
  { code: "ceb", name: "Cebuano", english: "Cebuano", flag: "🇵🇭" },
  { code: "ilo", name: "Ilokano", english: "Ilocano", flag: "🇵🇭" },
  { code: "hil", name: "Hiligaynon", english: "Hiligaynon", flag: "🇵🇭" },
  { code: "bik", name: "Bikol", english: "Bikol", flag: "🇵🇭" },
  { code: "war", name: "Waray", english: "Waray", flag: "🇵🇭" },
  { code: "ta", name: "தமிழ்", english: "Tamil", flag: "🇮🇳" },
  { code: "te", name: "తెలుగు", english: "Telugu", flag: "🇮🇳" },
  { code: "ml", name: "മലയാളം", english: "Malayalam", flag: "🇮🇳" },
  { code: "kn", name: "ಕನ್ನಡ", english: "Kannada", flag: "🇮🇳" },
  { code: "si", name: "සිංහල", english: "Sinhala", flag: "🇱🇰" },
  { code: "ne", name: "नेपाली", english: "Nepali", flag: "🇳🇵" },
  { code: "ur", name: "اردو", english: "Urdu", flag: "🇵🇰" },
  { code: "gu", name: "ગુજરાતી", english: "Gujarati", flag: "🇮🇳" },
  { code: "mr", name: "मराठी", english: "Marathi", flag: "🇮🇳" },

  // European Languages
  { code: "de", name: "Deutsch", english: "German", flag: "🇩🇪" },
  { code: "fr", name: "Français", english: "French", flag: "🇫🇷" },
  { code: "it", name: "Italiano", english: "Italian", flag: "🇮🇹" },
  { code: "nl", name: "Nederlands", english: "Dutch", flag: "🇳🇱" },
  { code: "pl", name: "Polski", english: "Polish", flag: "🇵🇱" },
  { code: "uk", name: "Українська", english: "Ukrainian", flag: "🇺🇦" },
  { code: "ro", name: "Română", english: "Romanian", flag: "🇷🇴" },
  { code: "el", name: "Ελληνικά", english: "Greek", flag: "🇬🇷" },
  { code: "hu", name: "Magyar", english: "Hungarian", flag: "🇭🇺" },
  { code: "cs", name: "Čeština", english: "Czech", flag: "🇨🇿" },
  { code: "sv", name: "Svenska", english: "Swedish", flag: "🇸🇪" },
  { code: "da", name: "Dansk", english: "Danish", flag: "🇩🇰" },
  { code: "fi", name: "Suomi", english: "Finnish", flag: "🇫🇮" },
  { code: "no", name: "Norsk", english: "Norwegian", flag: "🇳🇴" },
  { code: "hr", name: "Hrvatski", english: "Croatian", flag: "🇭🇷" },
  { code: "sr", name: "Српски", english: "Serbian", flag: "🇷🇸" },
  { code: "bg", name: "Български", english: "Bulgarian", flag: "🇧🇬" },
  { code: "sk", name: "Slovenčina", english: "Slovak", flag: "🇸🇰" },
  { code: "lt", name: "Lietuvių", english: "Lithuanian", flag: "🇱🇹" },
  { code: "lv", name: "Latviešu", english: "Latvian", flag: "🇱🇻" },
  { code: "et", name: "Eesti", english: "Estonian", flag: "🇪🇪" },
  { code: "is", name: "Íslenska", english: "Icelandic", flag: "🇮🇸" },
  { code: "ga", name: "Gaeilge", english: "Irish", flag: "🇮🇪" },
  { code: "cy", name: "Cymraeg", english: "Welsh", flag: "🏴󠁧󠁢󠁷󠁬󠁳󠁿" },
  { code: "gd", name: "Gàidhlig", english: "Scottish Gaelic", flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿" },

  // Middle Eastern Languages
  { code: "fa", name: "فارسی", english: "Persian", flag: "🇮🇷" },
  { code: "he", name: "עברית", english: "Hebrew", flag: "🇮🇱" },
  { code: "tr", name: "Türkçe", english: "Turkish", flag: "🇹🇷" },
  { code: "ku", name: "Kurdî", english: "Kurdish", flag: "🇮🇶" },
  { code: "az", name: "Azərbaycan", english: "Azerbaijani", flag: "🇦🇿" },
  { code: "hy", name: "Հայերեն", english: "Armenian", flag: "🇦🇲" },
  { code: "ka", name: "ქართული", english: "Georgian", flag: "🇬🇪" },

  // African Languages
  { code: "sw", name: "Kiswahili", english: "Swahili", flag: "🇹🇿" },
  { code: "am", name: "አማርኛ", english: "Amharic", flag: "🇪🇹" },
  { code: "ha", name: "Hausa", english: "Hausa", flag: "🇳🇬" },
  { code: "yo", name: "Yorùbá", english: "Yoruba", flag: "🇳🇬" },
  { code: "ig", name: "Igbo", english: "Igbo", flag: "🇳🇬" },
  { code: "zu", name: "isiZulu", english: "Zulu", flag: "🇿🇦" },
  { code: "xh", name: "isiXhosa", english: "Xhosa", flag: "🇿🇦" },
  { code: "af", name: "Afrikaans", english: "Afrikaans", flag: "🇿🇦" },

  // Americas
  { code: "qu", name: "Runasimi", english: "Quechua", flag: "🇵🇪" },
  { code: "ay", name: "Aymar aru", english: "Aymara", flag: "🇧🇴" },
  { code: "gn", name: "Avañe'ẽ", english: "Guarani", flag: "🇵🇾" },
  { code: "nah", name: "Nahuatl", english: "Nahuatl", flag: "🇲🇽" },
  { code: "ht", name: "Kreyòl ayisyen", english: "Haitian Creole", flag: "🇭🇹" }
];

export type LanguageContextType = {
  current_language: Language;
  set__language: (language: Language) => void;
  isLoading?: boolean;
}; 